import { Flex } from '@mantine/core'
import styled from 'styled-components'

export const PriceTabsStyled = styled.div`
  width: 100%;
  position: sticky;
  top: var(--header-height);
  z-index: 8;
  background-color: var(--color-bg-1);

  .mantine-GateTabs-tab {
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }

  .mantine-GateTabs-controlWrapper {
    &[data-dir='prev'] {
      left: -3px;
      height: calc(100% + 2px) !important;
    }
    &[data-dir='next'] {
      right: -2px;
      height: calc(100% + 2px) !important;
    }
  }

  &[data-dark='true'] {
    .mantine-GateTabs-controlWrapper,
    .gui-mantine-rtl-GateTabs-controlWrapper {
      &[data-dir='next'],
      &[data-dir='prev'] {
        background: linear-gradient(to right, rgba(26, 28, 35, 0), #14141a 25%);
        padding: 0;
        width: 14px;
      }
    }
  }
`

export const PriceTabsItemStyled = styled.a`
  color: inherit;
`

export const OtherTabWrapStyled = styled.div`
  width: 100%;
`

export const OtherTabListStyled = styled(Flex)`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-left: 8px;
  padding-right: 6px;
  max-height: 216px;
`

export const OtherTabItemStyled = styled.a`
  width: 100%;
  padding: 10px 8px;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background: var(--color-neutral-2);
  }

  &[data-active='true'] {
    color: var(--color-text-5);
  }
`
